import ScreenTemplate from './ScreenTemplate'

export * from './ScreenTemplate'

export default ScreenTemplate
